module.exports = __webpack_public_path__ + "static/media/logo.acf6c562.png";


//////////////////
// WEBPACK FOOTER
// ./src/logo.png
// module id = 306
// module chunks = 0